import { useState } from 'react';
import Banner from './Banner';
import FilteredCar from './FilteredCar';

const FindCar = () => {
  const [filter, setFilter] = useState({
    by: '',
    value: '',
  });

  const bannerProps = { filter, setFilter };
  let heading=window.location.pathname === "/find_car"?"Market Value List":"Find Salvage Cars"
  const filteredCarProps = { filter,heading,pageType:window.location.pathname === "/find_car"?"MarketCars":"SalvageCars"};
  return (
    <>
      {/* <Banner {...bannerProps} /> */}
      <FilteredCar {...filteredCarProps} />
    </>
  );
};

export default FindCar;
